export default "__VITE_ASSET__07badf8d__"